import React from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import { COLORS, FONT } from "../../constants";
import useSystemHook from "../../hooks/SystemHook";

const KeyBenefits = ({ benefits }) => {
  const { isMobile } = useSystemHook();

  return (
    <Box sx={{ backgroundColor: "#f9f9f9", py: isMobile ? 6 : 8 }}>
      <Container maxWidth="lg">
        <Typography
          variant="h5"
          sx={{ fontWeight: 700, textAlign: "center", mb: 1, color: COLORS.themeBlack }}
        >
          Key Benefits Of Opening An Argus Account
        </Typography>
        <Typography
          sx={{
            textAlign: "center",
            color: COLORS.lightText,
            mb: 6,
            fontSize: isMobile ? FONT.size.xs : FONT.size.md,
          }}
        >
          Everything you need to run your spare shop efficiently.
        </Typography>

        <Grid container spacing={3}>
          {benefits.map((benefit, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Box
                sx={{
                  backgroundColor: COLORS.white,
                  border: `1px solid #e8e8e8`,
                  borderRadius: "4px",
                  overflow: "hidden",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
                }}
              >
                <Box
                  component="img"
                  src={benefit.image}
                  alt={benefit.title}
                  sx={{ width: "100%", height: 200, objectFit: "cover", display: "block" }}
                />
                <Box sx={{ p: 3, flex: 1 }}>
                  <Typography
                    sx={{
                      fontWeight: 700,
                      mb: 1.5,
                      color: COLORS.themeBlack,
                      fontSize: isMobile ? FONT.size.sm : FONT.size.base,
                      lineHeight: 1.3,
                      textAlign: "center",
                    }}
                  >
                    {benefit.title}
                  </Typography>
                  <Typography
                    sx={{
                      color: COLORS.lightText,
                      fontSize: isMobile ? FONT.size.xs : FONT.size.sm,
                      lineHeight: 1.7,
                      textAlign: "center",
                    }}
                  >
                    {benefit.description}
                  </Typography>
                </Box>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default KeyBenefits;
